import src from "IMAGE";
export default { src, width: 160, height: 160, blurWidth: 0, blurHeight: 0};
